import { create } from 'zustand';

interface SessionState {
  accessToken: string | null;
  accessTokenExpiresAt: number | null;
  setAccessToken: (accessToken: string, accessTokenExpiresAt: number) => void;
  clearSession: () => void;
}

/**
 * The whole of client state: an in-memory access token and its expiry.
 *
 * Everything else is server state and lives in TanStack Query - the signed-in
 * user included (see features/auth/auth-queries.ts). The refresh token is an
 * HttpOnly cookie and is never visible here. Nothing is persisted: the token is
 * memory-only by design, and a page reload re-establishes the session from the
 * refresh cookie instead.
 *
 * Tenant and branch context deliberately absent - the first feature is a sole
 * proprietorship with a single admin user (ADR-first-feature-scope).
 */
export const useSessionStore = create<SessionState>()((set) => ({
  accessToken: null,
  accessTokenExpiresAt: null,

  setAccessToken: (accessToken, accessTokenExpiresAt) => {
    set({ accessToken, accessTokenExpiresAt });
  },

  clearSession: () => {
    set({ accessToken: null, accessTokenExpiresAt: null });
  },
}));

export const useIsAuthenticated = (): boolean =>
  useSessionStore((state) => state.accessToken !== null);
